import { buildService } from '@rd-web-markets/shared/dist/services/service';
import serviceMethods from '@rd-web-markets/shared/dist/services/service_methods';
import { UserService } from '@rd-web-markets/shared/dist/services/user.service';
import { replaceInArray } from '@rd-web-markets/shared/dist/util/arrayUtils/arrayUtils';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
const api = buildService('/claim_project_reports/{id}/competent_professionals_users', {
  only: ['create', 'update']
});
const useCreate = _ref => {
  let {
    claimProjectReportId,
    setLoading
  } = _ref;
  const createUser = serviceMethods.useCreate({
    callback: useCallback(async competentProfessional => {
      return await api.create(claimProjectReportId, {
        competent_professional_id: competentProfessional.id
      });
    }, [claimProjectReportId]),
    setLoading
  });
  return createUser;
};
const useUpdate = _ref2 => {
  let {
    claimProjectReportId,
    setLoading
  } = _ref2;
  const createUser = serviceMethods.useCreate({
    callback: useCallback(async (competentProfessional, technical_review) => {
      return await api.update(claimProjectReportId, competentProfessional.id, {
        technical_review
      });
    }, [claimProjectReportId]),
    setLoading
  });
  return createUser;
};
const useCreateOrUpdateUser = _ref3 => {
  let {
    claimProjectReportId,
    setLoading,
    confirmUpdateMessage,
    confirmCreateMessage
  } = _ref3;
  const [,, fetchExistingUsers] = UserService.useFetch({
    setLoading,
    fetchImediately: false
  });
  const create = useCreate({
    claimProjectReportId,
    setLoading
  });
  const update = useUpdate({
    claimProjectReportId,
    setLoading
  });

  // queryJson can be { email: 'string' } or something like that
  const createOrUpdateUser = useCallback(async (competentProfessional, technicalReview) => {
    const existingUser = (await fetchExistingUsers({
      query: competentProfessional.email
    })).users[0];
    let result = null;
    if (existingUser) {
      if (confirmUpdateMessage && !confirm(confirmUpdateMessage)) {
        return null;
      } else {
        result = await update(competentProfessional, technicalReview);
      }
    } else {
      if (confirmCreateMessage && !confirm(confirmCreateMessage)) {
        return null;
      } else {
        // always created with technicalReview true by default
        result = await create(competentProfessional);
      }
    }
    return result;
  }, [confirmCreateMessage, confirmUpdateMessage, create, fetchExistingUsers, update]);
  return createOrUpdateUser;
};
const competentProfessionalsUsersService = {
  useCreate,
  useCreateOrUpdateUser
};
export default competentProfessionalsUsersService;